import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { SMALL_MOBILE_HEIGHT } from '../consts'

interface IBulkActionsStyledProps {
  $isToneVisible: boolean
}

export const TtsBulkActionsWrapper = styled.div<IBulkActionsStyledProps>`
  padding-top: 20px;
  margin: 0 15px;
  overflow: visible;
  border-bottom: 1px solid ${COLORS.borderLayout};

  ${({ $isToneVisible }) =>
    $isToneVisible
      ? css`
          padding-bottom: 20px;
        `
      : css`
          padding-bottom: 12px;
        `}

  justify-content: flex-start;
  gap: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}) {
    padding-top: 4px;
    height: auto;
    gap: 12px;
  }

  @media screen and (max-height: ${SMALL_MOBILE_HEIGHT}px) {
    margin-right: 10px;
  }

  .icon-with-tooltip {
    margin-bottom: 4px;
  }
`

export const SpeakerDropdownWrapper = styled.div<{
  $isBulkLanguageUndefined: boolean
}>`
  flex-grow: 1;

  .bulk-speaker-dropdown {
    flex-grow: 1;
    pointer-events: ${({ $isBulkLanguageUndefined }) =>
      $isBulkLanguageUndefined ? 'none' : 'auto'};
  }
`
